/* eslint max-classes-per-file: 0 */

import {
  MunMeh as Data,
  MunMehCollection as Collection,
} from '@/typings/api/MunMeh'
import { MunMehApi as Api } from '@/api/resources'

import { Fabric } from '@/store/createCrudModule'


const { TransformerParams, Adapter } = Fabric<Data, Collection>()

export class PublicationMunMehTransformerParams extends TransformerParams {
  protected defaultParams = [
    'publication_id',
  ];
}

export class PublicationMunMehAdapter extends Adapter<Api> {
  public readonly api = new Api();

  public readonly transformerParams = new PublicationMunMehTransformerParams();
}
